import { Home } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import Logo from '../assets/images/logo/starcard_club_white.png';

const NotFoundPage = () => {
  const redirectPage = () => {
    window.location.href = '/';
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        backgroundColor: '#E1000C',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 20px',
      }}
    >
      <Box
        component={'img'}
        src={Logo}
        alt="Caltex Starcard Club Logo"
        sx={{ width: '100%', maxWidth: '220px' }}
      />
      <Typography
        component="h1"
        sx={{
          fontSize: '10rem',
          fontWeight: 'bold',
          lineHeight: 1,
          color: 'white',
          textAlign: 'center',
          letterSpacing: '10px',
        }}
      >
        404
      </Typography>
      <Typography
        component="h2"
        sx={(theme) => ({
          fontSize: '2rem',
          lineHeight: 1,
          fontWeight: '500',
          color: 'white',
          marginBottom: '25px',
          textAlign: 'center',

          [theme.breakpoints.up('sm')]: {
            fontSize: '2.5rem',
          },
        })}
      >
        Oops! You've strayed too far.
      </Typography>
      <Typography
        sx={(theme) => ({
          fontSize: '1.125rem',
          lineHeight: 1,
          fontWeight: '300',
          color: '#fafafa',
          marginBottom: '60px',
          textAlign: 'center',

          [theme.breakpoints.up('sm')]: {
            fontSize: '1.5rem',
          },
        })}
      >
        The page you are looking for doesn't exist. <br />
        It might have been moved, deleted, or you might have mistyped the address.
      </Typography>
      <Button
        variant="contained"
        sx={{
          width: '200px',
          height: '45px',
          margin: '0 auto',
          textTransform: 'capitalize',
          color: 'white',
          backgroundColor: '#005972',
          fontSize: '1.25rem',
          lineHeight: 1,
          borderRadius: '15px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',

          '&:hover': {
            color: 'white',
            backgroundColor: '#005972',
            opacity: '.85',
          },
        }}
        onClick={redirectPage}
      >
        <Home />
        Back to Homepage
      </Button>
    </Box>
  );
};

export default NotFoundPage;
